export enum RateImportStatusEnum {
  Success = 1,
  Processing = 2,
  Error = 3,
  Scheduled = 4
}
